import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Trip, TripDisplay, transformTrip } from "@/lib/trips";

export const useTrip = (tripId: string | null) => {
  return useQuery({
    queryKey: ["trip", tripId],
    queryFn: async (): Promise<TripDisplay | null> => {
      if (!tripId) return null;

      // Check if Supabase is configured
      if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
        console.warn('Supabase not configured.');
        return null;
      }

      try {
        const { data, error } = await supabase
          .from("trips")
          .select("*")
          .eq("id", tripId)
          .single();

        if (error) {
          console.error('Error fetching trip:', error);
          throw error;
        }

        return data ? transformTrip(data as Trip) : null;
      } catch (error) {
        console.error('Error in useTrip:', error);
        return null;
      }
    },
    enabled: !!tripId,
    retry: false,
  });
};

